import {Component, Input, OnInit} from '@angular/core';
import {InstagramService} from '../../../../services/social/instagram.service';
import {ToastrService} from 'ngx-toastr';


@Component({
  selector: 'app-instagram-analytics',
  templateUrl: './instagram-analytics.component.html',
  styleUrls: ['./instagram-analytics.component.css']
})
export class InstagramAnalyticsComponent implements OnInit {
  Math = Math;
  @Input() feedItems: any = [];
  @Input() pageInsights: any = {};
  @Input() pageInsightsLoaded: boolean;
  totalItems = 0;
  instagramName: string;
  instagramActivePage = {
    'followers_count': 0
  };

  instagramAnalytics = {
    'totalLikes': 0,
    'totalComments': 0
  };

  constructor(private instagramService: InstagramService,
              private toaster: ToastrService) {
    instagramService.instagramDetails().subscribe(response => {
      this.instagramName = response.data.payload.username;
    });
  }

  ngOnInit() {
    this.totalItems = this.pageInsights.summary.media_count || 0;
    this.instagramActivePage.followers_count = this.pageInsights.summary.followers_count || 0;
    this.instagramAnalytics = this.pageInsights.summary.media.data.reduce((acc: any, rec: any) => {
      acc.totalLikes += (rec.like_count || 0);
      acc.totalComments += (rec.comments_count || 0);
      return acc;
    }, {
      totalLikes: 0,
      totalComments: 0,
    });
  }


  getMediaTypeCount(type: string): number {
    return (this.feedItems || []).filter((p: any) => {
      return p.media_type === type;
    }).length;
  }

  getMediaTypePercent(type: string): number {
    if (!this.feedItems.length) {
      return 0;
    }
    return Math.round((this.getMediaTypeCount(type) / this.feedItems.length) * 100);
  }

  getAvgEngagement(): string {
    if (!this.feedItems.length) {
      return '0';
    }
    const total = this.feedItems.reduce((sum: number, p: any) => {
      return sum + (p.like_count || 0) + (p.comments_count || 0);
    }, 0);
    return Math.round(total / this.feedItems.length).toLocaleString();
  }

  getInitials(username: string): string {
    if (!username || typeof username !== 'string') {
      return 'IG';
    }
    return username.slice(0, 2).toUpperCase();
  }
}
